import { useState } from "react";
import Layout from '../../components/Layout.js';
import LazyImg from '../../components/LazyImg.js';
import './Contact.css';

import arxiv from './../../assets/logos/arxiv.svg'

const REASONS = [
    "Job opportunity",
    "Research collaboration",
    "Project idea",
    "Just saying hi",
    "Other",
];

export default function Contact() {
    const [form, setForm] = useState({ name: "", email: "", reason: "", message: "" });
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
    };

    const handleSubmit = async () => {
        if (!form.name || !form.email || !form.message) return;
        setLoading(true);

        try {
            const res = await fetch("https://formspree.io/f/mwvjgapd", {
                method: "POST",
                headers: { "Content-Type": "application/json", "Accept": "application/json" },
                body: JSON.stringify({
                    name: form.name,
                    email: form.email,
                    reason: form.reason,
                    message: form.message,
                }),
            });

            if (res.ok) {
                setSubmitted(true);
            } else {
                alert("Something went wrong. Please try again.");
            }
        } catch {
            alert("Network error. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout pageIndex={5}>
            <div className="contact-page">


                {/* ── HERO ── */}
                <div className="contact-hero page-hero noise">
                    <div className="contact-page-header">
                        <div style={{ maxWidth: "80%", zIndex: "2" }}>
                            <p className="section-eyebrow">Get in touch</p>
                            <h1 className="contact-hero-title" style={{minWidth:"200px"}}>Let's build together!</h1>
                            <p className="exp-page-sub">
                                Thanks for visiting my site! Feel free to reach out
                                if you have a project in mind or want to connect.
                            </p>
                        </div>
                        <LazyImg
                            imageKey="snowman"
                            style={{ width: "100%", maxWidth:"100px", minWidth:"140px", aspectRatio: "0.6", objectFit: "cover", objectPosition: "center top", zIndex: "1" }}
                            alt="Me building a snowman"
                        />
                    </div>

                </div>

                {/* ── BODY ── */}
                <div className="contact-body">

                    {/* Form */}
                    <div className="contact-form-wrap">
                        <p className="contact-form-title">Send a message</p>

                        {submitted ? (
                            <div className="form-success">
                                <div className="form-success-icon">✓</div>
                                <h3>Message sent!</h3>
                                <p>Thanks for reaching out, {form.name.split(" ")[0]}. I'll get back to you as soon as I can.</p>
                            </div>
                        ) : (
                            <>
                                <div className="form-row">
                                    <div className="form-field">
                                        <label htmlFor="name">Name</label>
                                        <input
                                            id="name"
                                            name="name"
                                            type="text"
                                            placeholder="Jane Smith"
                                            value={form.name}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="form-field">
                                        <label htmlFor="email">Email</label>
                                        <input
                                            id="email"
                                            name="email"
                                            type="email"
                                            placeholder="jane@example.com"
                                            value={form.email}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className="form-field">
                                    <label htmlFor="reason">Reason for reaching out</label>
                                    <select id="reason" name="reason" value={form.reason} onChange={handleChange}>
                                        <option value="">Select one…</option>
                                        {REASONS.map((r) => <option key={r} value={r}>{r}</option>)}
                                    </select>
                                </div>

                                <div className="form-field">
                                    <label htmlFor="message">Message</label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        placeholder="Tell me what's on your mind…"
                                        value={form.message}
                                        onChange={handleChange}
                                    />
                                </div>

                                <button
                                    className="submit-btn"
                                    onClick={handleSubmit}
                                    disabled={loading || !form.name || !form.email || !form.message}
                                >
                                    {loading ? "Sending…" : "Send message →"}
                                </button>
                            </>
                        )}
                    </div>

                    {/* Sidebar */}
                    <aside className="contact-sidebar">
                        <div className="sidebar-card">
                            <p className="sidebar-card-title">Find me online</p>

                            <a href="https://www.linkedin.com/in/michael-p-reidy/" className="contact-link-row" target="_blank" rel="noreferrer">
                                <div className="contact-link-icon">in</div>
                                <div className="contact-link-info">
                                    <span className="contact-link-label">LinkedIn</span>
                                    <span className="contact-link-handle">michael-p-reidy</span>
                                </div>
                            </a>

                            <a href="https://github.com/notred27" className="contact-link-row" target="_blank" rel="noreferrer">
                                <div className="contact-link-icon">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M12 0C5.37 0 0 5.37 0 12c0 5.3 3.44 9.8 8.2 11.39.6.11.82-.26.82-.58v-2.03c-3.34.73-4.04-1.61-4.04-1.61-.55-1.39-1.34-1.76-1.34-1.76-1.09-.74.08-.73.08-.73 1.21.09 1.84 1.24 1.84 1.24 1.07 1.84 2.81 1.3 3.49 1 .11-.78.42-1.3.76-1.6-2.67-.3-5.47-1.33-5.47-5.93 0-1.31.47-2.38 1.24-3.22-.14-.3-.54-1.52.12-3.18 0 0 1.01-.32 3.3 1.23a11.5 11.5 0 0 1 3-.4c1.02 0 2.04.14 3 .4 2.28-1.55 3.29-1.23 3.29-1.23.66 1.66.25 2.88.12 3.18.77.84 1.23 1.91 1.23 3.22 0 4.61-2.81 5.63-5.48 5.92.43.37.81 1.1.81 2.22v3.29c0 .32.22.7.83.58C20.57 21.8 24 17.3 24 12c0-6.63-5.37-12-12-12z" />
                                    </svg>
                                </div>
                                <div className="contact-link-info">
                                    <span className="contact-link-label">GitHub</span>
                                    <span className="contact-link-handle">notred27</span>
                                </div>
                            </a>

                            <a href="https://arxiv.org/search/cs?searchtype=author&query=Reidy%2C+M" className="contact-link-row" target="_blank" rel="noreferrer">
                                <img className="contact-link-icon" src={arxiv} alt="" />
                                <div className="contact-link-info">
                                    <span className="contact-link-label">arXiv</span>
                                    <span className="contact-link-handle">Michael Reidy</span>
                                </div>
                            </a>

                            <a href="https://orcid.org/0009-0002-6850-032X" className="contact-link-row" target="_blank" rel="noreferrer">
                                <div className="contact-link-icon">iD</div>
                                <div className="contact-link-info">
                                    <span className="contact-link-label">ORCID</span>
                                    <span className="contact-link-handle">0009-0002-6850-032X</span>
                                </div>
                            </a>
                        </div>
                    </aside>
                </div>
            </div>
        </Layout>
    );
}